// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-PcZA","title":"styles_title__sIsBE","description":"styles_description__6Y9jV","form":"styles_form__S2WUe"};